import { delay, put } from 'redux-saga/effects';

import { IKnm } from 'APIPackage/KnmModule/interfaces/IKnm';
import { fetchKnmDeleteById } from 'APIPackage/KnmModule/services/knmApi';
import { addNoticeAction } from 'CorePackage/NotificationModule/actions/NoticeActions';
import { NoticeTypesEnum } from 'CorePackage/NotificationModule/enums/NoticeTypesEnum';
import { MessageTypesEnum } from 'CorePackage/NotificationModule/enums/MessageTypesEnum';
import { REFRESH_DELAY } from 'CorePackage/MainModule/constants/refreshDelay';

export function* knmDeleteSagaFunc(ids: Array<IKnm['id']>, isPm?: boolean) {
  const actions = ids.map(async (id: IKnm['id']) => {
    await fetchKnmDeleteById(id);
  });

  yield Promise.all(actions);
  yield delay(REFRESH_DELAY);
  yield put(
    addNoticeAction({
      renderContent: `${isPm ? 'ПМ' : 'КНМ'} успешно ${ids.length > 1 ? 'удалены' : 'удален'}.`,
      noticeType: NoticeTypesEnum.SUCCESS,
      messageType: MessageTypesEnum.DELETE_SUCCESS,
    }),
  );
}
